// import React from "react";
// import { motion } from "framer-motion";
// import { ChevronDown } from "lucide-react";

// const sections = [
//   {
//     title: "Creativity",
//     text: `Codex Future Technologies has proven past experience, in terms of creativity and quality.
//            It provides unique web designs and themes for their clients as per their requirements
//            and budget to make every website stand out from the crowd. Our experienced web
//            development team works wholeheartedly to meet your business needs.`,
//     img: "/ecom1.jpg",
//   },
//   {
//     title: "Responsive",
//     text: `Our responsive designs adapt seamlessly across devices. Whether it’s a laptop,
//            tablet, or smartphone, Codex Future Technologies ensures your website looks perfect everywhere.
//            We focus on usability and accessibility to provide an intuitive browsing experience.`,
//     img: "./ecom2.jpg",
//     reverse: true,
//   },
//   {
//     title: "Dynamic",
//     text: `Modern websites are optimized for all devices and feature intuitive designs.
//            With dynamic content, voice search capabilities, and smart interactions,
//            we create sites that are both engaging and functional for every user.`,
//     img: "./ecom3.jpg",
//   },
//   {
//     title: "Customised",
//     text: `For market development, we craft solid customized websites with maximum options
//            that are easy to manage. Our affordable web design team spends the time it takes
//            to make your site productive, beautiful, and unique to your brand.`,
//     img: "./ecom4.jpg",
//     reverse: true,
//   },
// ];

// const ScrollSection = ({ children }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 60 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.7, ease: "easeOut" }}
//     viewport={{ once: false, amount: 0.3 }}
//   >
//     {children}
//   </motion.div>
// );

// export default function WebDevelopmentTailwind() {
//   const handleScroll = () => {
//     document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
//   };

//  return (
//   <div className="font-poppins text-gray-100 overflow-x-hidden scroll-smooth relative bg-black">

//     {/* Luxury Gold Glow Background */}
//     <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0d0d0d] to-black">
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(212,175,55,0.15),_transparent_60%)]"></div>
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(212,175,55,0.18),_transparent_70%)]"></div>
//     </div>

//     {/* Hero Section */}
//     <ScrollSection>
//       <section className="relative h-screen flex flex-col items-center justify-center text-center overflow-hidden">

//         <motion.h1
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="text-[64px] font-extrabold uppercase tracking-wider mb-5 
//           bg-clip-text text-transparent 
//           bg-gradient-to-r from-[#C5A46D] via-[#E7C787] to-[#C5A46D]
//           drop-shadow-[0_4px_10px_rgba(212,175,55,0.5)]"
//         >
//           ECommerce Solutions
//         </motion.h1>

//         <motion.p
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           className="text-[20px] max-w-2xl text-gray-300 leading-relaxed"
//         >
//           Why are we the best Web Development Company in Indore?
//         </motion.p>

//         <motion.div
//           className="absolute bottom-20 cursor-pointer animate-bounce text-[#E7C787]"
//           onClick={handleScroll}
//           whileHover={{ scale: 1.2 }}
//         >
//           <ChevronDown size={42} />
//         </motion.div>
//       </section>
//     </ScrollSection>

//     {/* Sections */}
//     <div id="web-sections" className="max-w-6xl mx-auto py-24 px-6 md:px-10 space-y-24 relative z-10">
//       {sections.map(({ title, text, img, reverse }, idx) => (
//         <ScrollSection key={idx}>
//           <div
//             className={`flex flex-col md:flex-row items-center gap-12 ${
//               reverse ? "md:flex-row-reverse" : ""
//             }`}
//           >
//             {/* Text */}
//             <motion.div
//               className="flex-1 bg-black/60 border border-[#D4AF37]/30 
//               backdrop-blur-xl p-10 md:p-12 rounded-[20px] 
//               shadow-[0_10px_25px_rgba(212,175,55,0.15)]
//               hover:shadow-[0_14px_35px_rgba(212,175,55,0.25)]
//               transition-all duration-300"
//               whileHover={{ y: -5 }}
//             >
//               <h2 className="text-[38px] md:text-[38px] font-bold mb-4 relative 
//                 bg-clip-text text-transparent 
//                 bg-gradient-to-r from-[#E5C07B] to-[#F6E7C1]
//                 after:block after:w-20 after:h-1 
//                 after:bg-[#D4AF37] after:rounded mt-2"
//               >
//                 {title}
//               </h2>

//               <p className="text-[17px] md:text-[17px] leading-relaxed text-gray-300">
//                 {text}
//               </p>
//             </motion.div>

//             {/* Image */}
//             <motion.div
//               className="flex-1 text-center"
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.4 }}
//             >
//               <img
//                 src={img}
//                 alt={title}
//                 className="w-full max-w-md md:max-w-lg rounded-[20px]
//                 shadow-[0_12px_30px_rgba(212,175,55,0.20)]"
//               />
//             </motion.div>
//           </div>
//         </ScrollSection>
//       ))}
//     </div>

//     {/* Bounce Animation */}
//     <style>{`
//       @keyframes bounce {
//         0%,100% { transform: translateY(0); }
//         50% { transform: translateY(10px); }
//       }
//       .animate-bounce {
//         animation: bounce 1.8s infinite;
//       }
//     `}</style>
//   </div>
// );

// }




import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const sections = [
  {
    title: "Creativity",
    text: `Codex Future Technologies has proven past experience, in terms of creativity and quality.
           It provides unique web designs and themes for their clients as per their requirements
           and budget to make every website stand out from the crowd. Our experienced web
           development team works wholeheartedly to meet your business needs.`,
    img: "/ecom1.jpg",
  },
  {
    title: "Responsive",
    text: `Our responsive designs adapt seamlessly across devices. Whether it’s a laptop,
           tablet, or smartphone, Codex Future Technologies ensures your website looks perfect everywhere.
           We focus on usability and accessibility to provide an intuitive browsing experience.`,
    img: "/ecom2.jpg",
    reverse: true,
  },
  {
    title: "Dynamic",
    text: `Modern websites are optimized for all devices and feature intuitive designs.
           With dynamic content, voice search capabilities, and smart interactions,
           we create sites that are both engaging and functional for every user.`,
    img: "/ecom3.jpg",
  },
  {
    title: "Customised",
    text: `For market development, we craft solid customized websites with maximum options
           that are easy to manage. Our affordable web design team spends the time it takes
           to make your site productive, beautiful, and unique to your brand.`,
    img: "/ecom4.jpg",
    reverse: true,
  },
];

const ScrollSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

export default function WebDevelopmentTailwind() {
  const handleScroll = () => {
    document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-poppins text-gray-100 overflow-x-hidden scroll-smooth relative bg-black">

      {/* Luxury Gold Glow Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0d0d0d] to-black">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(212,175,55,0.15),_transparent_60%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(212,175,55,0.18),_transparent_70%)]"></div>
      </div>

      {/* Hero Section */}
      <ScrollSection>
        <section className="relative h-[80vh] md:h-screen flex flex-col items-center justify-center text-center px-4">

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-[36px] sm:text-[48px] md:text-[64px] font-extrabold uppercase tracking-wider mb-4 
            bg-gradient-to-r from-[#C5A46D] via-[#E7C787] to-[#C5A46D]
            text-transparent bg-clip-text drop-shadow-[0_4px_10px_rgba(212,175,55,0.5)]"
          >
            ECommerce Solutions
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-[16px] sm:text-[18px] md:text-[20px] max-w-xl md:max-w-2xl text-gray-300 leading-relaxed px-2"
          >
            Why are we the best Web Development Company in Indore?
          </motion.p>

          <motion.div
            className="absolute bottom-16 cursor-pointer animate-bounce text-[#E7C787]"
            onClick={handleScroll}
            whileHover={{ scale: 1.2 }}
          >
            <ChevronDown size={38} className="sm:size-42" />
          </motion.div>
        </section>
      </ScrollSection>

      {/* Sections */}
      <div id="web-sections" className="max-w-6xl mx-auto py-16 sm:py-20 md:py-24 px-4 sm:px-8 space-y-16 sm:space-y-20 md:space-y-24">

        {sections.map(({ title, text, img, reverse }, idx) => (
          <ScrollSection key={idx}>
            <div
              className={`flex flex-col md:flex-row items-center gap-8 md:gap-12 ${
                reverse ? "md:flex-row-reverse" : ""
              }`}
            >

              {/* Text */}
              <motion.div
                className="flex-1 bg-black/60 border border-[#D4AF37]/30 
                backdrop-blur-xl p-6 sm:p-8 md:p-12 rounded-[20px] 
                shadow-[0_10px_25px_rgba(212,175,55,0.15)]
                hover:shadow-[0_14px_35px_rgba(212,175,55,0.25)]
                transition-all duration-300 text-center md:text-left"
                whileHover={{ y: -5 }}
              >
                <h2 className="text-[28px] sm:text-[32px] md:text-[38px] font-bold mb-3 
                bg-gradient-to-r from-[#E5C07B] to-[#F6E7C1]
                text-transparent bg-clip-text relative
                after:block after:w-14 sm:after:w-20 after:h-1 
                after:bg-[#D4AF37] after:rounded mx-auto md:mx-0 mt-2"
                >
                  {title}
                </h2>

                <p className="text-[15px] sm:text-[16px] md:text-[17px] leading-relaxed text-gray-300">
                  {text}
                </p>
              </motion.div>

              {/* Image */}
              <motion.div
                className="flex-1 text-center"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  src={img}
                  alt={title}
                  className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-[20px]
                  shadow-[0_12px_30px_rgba(212,175,55,0.20)] border border-[#D4AF37]/20"
                />
              </motion.div>
            </div>
          </ScrollSection>
        ))}
      </div>

      {/* Bounce Animation */}
      <style>{`
        @keyframes bounce {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(12px); }
        }
        .animate-bounce {
          animation: bounce 1.8s infinite;
        }
      `}</style>
    </div>
  );
}
